export class JobSingle {
  constructor() {
    const jobHeader = document.querySelector('._job-header');
    const jobAside = document.querySelector('._job-header__aside');
    const jobAsideWrapper = document.querySelector('._job-header__aside .wpb_wrapper');

    function jobAsideFloating(wpadminbar) {
        if (
            window.innerWidth >= 992 &&
            window.scrollY >= 80 &&
            window.scrollY < jobHeader.offsetHeight - jobAsideWrapper.offsetHeight - 72 - 35
        ) {
            jobAsideWrapper.style.position = 'fixed';
            jobAsideWrapper.style.top = (wpadminbar ? 147 : 115) + 'px';
            jobAsideWrapper.style.width = jobAside.offsetWidth - 30 + 'px';
        } else if (
            window.innerWidth >= 992 &&
            window.scrollY >= jobHeader.offsetHeight - jobAsideWrapper.offsetHeight - 72 - 35
        ) {
            jobAsideWrapper.style.position = 'absolute';
            jobAsideWrapper.style.top = jobHeader.offsetHeight - jobAsideWrapper.offsetHeight - 72 - 115 + 'px';
            jobAsideWrapper.style.width = jobAside.offsetWidth - 30 + 'px';
        } else {
            jobAsideWrapper.style.position = null;
            jobAsideWrapper.style.top = null;
            jobAsideWrapper.style.width = null;
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        if ( jobAside ) {
            const wpadminbar = document.querySelector('#wpadminbar');

            window.addEventListener('scroll', () => jobAsideFloating(wpadminbar));
            window.addEventListener('resize', () => jobAsideFloating(wpadminbar));
        }
    });

    // const formLinkInline = document.querySelector('.form-link--inline');

    // const observer = new IntersectionObserver(entries => {
    //     const chatWidget = document.querySelector('.intercom-lightweight-app-launcher');

    //     entries.forEach((entry) => {
    //         if (entry.isIntersecting) {
    //             if (formLinkInline) {
    //                 formLinkInline.style.transform = 'translateY(100%)';
    //             }

    //             if (chatWidget) {
    //                 chatWidget.style.transform = 'none';
    //             }
    //         } else {
    //             if (formLinkInline) {
    //                 formLinkInline.style.transform = 'none';
    //             }

    //             if (chatWidget) {
    //                 chatWidget.style.transform = 'translateY(-86px)';
    //             }
    //         }
    //     });
    // }, {
    //     rootMargin: '-80px 0px 0px 0px'
    // });

    // if (jobHeader) {
    //     observer.observe(jobHeader);
    // }
  }
}

export default new JobSingle;
